<template>
  <div>
    <h4 class="ui dividing header">
      Transactions Audit
    </h4>
    <abstractTable
      :columns="transactionsColumns"
      :data="computedTransactions()"
      :hasFooter="true"
      :classes="'ui very compact left aligned celled center aligned table'"
    >
      <template slot="footerRow">
        <tr>
          <th></th>
          <th></th>
          <th style="font-weight: bold;">
            {{ 
              formatPrice(offLineTransactions) 
            }}
          </th>
          <th style="font-weight: bold;">
            {{ 
              formatPrice(onLineTransactions) 
            }}
          </th>
          <th :colspan="6"></th>
        </tr>
        <tr>
          <th></th>
          <th></th>
          <th :colspan="2" style="font-weight: bold;">
            Total = {{ formatPrice(offLineTransactions + onLineTransactions) }}
          </th>
          <th :colspan="6"></th>
        </tr>
      </template>
    </abstractTable>
  </div>
</template>

<script>
export default {
  components: {
    abstractTable: require('@/components/abstract_components/AbstractTable')
      .default
  },
  props: {
    transactions: { type: Array, required: true },
    reservationTransactions: { type: Array, required: true },
    reservations: { type: Array, required: true },
  },
  computed: {
    transactionsColumns () {
      return [
        { header: 'Patient', fieldName: 'name', show: true },
        { header: 'Package', fieldName: 'packageName', show: true },
        { header: 'Cash', fieldName: 'cash', show: true, width: '8%' },
        { header: 'Visa', fieldName: 'visa', show: true, width: '8%' },
        { header: 'Credit', fieldName: 'credit', show: true, width: '8%' },
        { header: 'debit', fieldName: 'debit', show: true, width: '8%' },
        { header: this.$t('description'), fieldName: 'description', show: true },
        { header: this.$t('paidAt'), fieldName: 'paid_at', show: true, width: '8%' },
        { header: 'receptionist', fieldName: 'receptionist', show: true },
        { header: 'Reservation', fieldName: 'reservation', show: true, html: true },
      ]
    },
    offLineTransactions () {
      return window._.sumBy(this.transactions, transaction => {
        return transaction.online ? 0 : Number(transaction.amount) 
      })
    },
    onLineTransactions () {
      return window._.sumBy(this.transactions, transaction => {
        return transaction.online ? Number(transaction.amount) : 0
      })
    }
  },
  methods: {
    computedTransactions () {
      let formlatedTransactions = []
      const reservationTransactionsByTransactionId =
        this.reservationTransactions.reduce((obj, rt) => ({...obj, [rt.transaction_id]: rt}), {})

      const reservationsById = 
        this.reservations.reduce((obj, reservation) => ({...obj, [reservation.id]: reservation}), {})
      
      window._.each(this.transactions, transaction => {
        const reservationTransaction = reservationTransactionsByTransactionId[transaction.id]
        const reservation = reservationsById[reservationTransaction.reservation_id]
        const patientName = reservation.patient.name
        const p = reservation.packages.find(p => p.id === reservationTransaction.package_id)

        formlatedTransactions.push({
          name: this.adjustName(patientName),
          packageName: p.name,
          cash: transaction.online ? '-' : this.formatPrice(transaction.amount),
          visa: transaction.online ? this.formatPrice(transaction.amount) : '-',
          credit: this.formatPrice(reservationTransaction.credit),
          debit: this.formatPrice(reservationTransaction.debit),
          description: transaction.description || '-',
          paid_at: window.moment(transaction.paid_at).format('hh:mm A'),
          receptionist: transaction.user.name,
          reservation: {
            functionality: () => {
              this.navigateTo('Show_Reservation', { key: 'params', value: { id: reservation.id } })
            },
            value: `<a style="cursor: pointer;text-decoration:underline">${reservation.id}</a>`,
            filteredValue: reservation.id
          }
        })
      })

      return formlatedTransactions
    },
  },
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/financial_system/daily_transactions_component/PatientTransactions.vue